export default __webpack_public_path__ + "static/barfplan-blog-promo@2x-2f92c2fb358cfa24a610b2e12eb219ff.png";